var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconNotificationDefault = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#AF7FF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0846 13.668C21.0512 13.668 21.8346 12.8845 21.8346 11.918C21.8346 10.9515 21.0512 10.168 20.0846 10.168C19.1181 10.168 18.3346 10.9515 18.3346 11.918C18.3346 12.8845 19.1181 13.668 20.0846 13.668ZM11.3346 10.7513H17.4106C17.2545 11.1086 17.168 11.5032 17.168 11.918C17.168 13.5288 18.4738 14.8346 20.0846 14.8346C20.7412 14.8346 21.3471 14.6177 21.8346 14.2515V17.7513C21.8346 18.3957 21.3123 18.918 20.668 18.918H19.5013V20.5472C19.5013 20.807 19.1871 20.9371 19.0034 20.7534L17.168 18.918H11.3346C10.6903 18.918 10.168 18.3957 10.168 17.7513V11.918C10.168 11.2736 10.6903 10.7513 11.3346 10.7513Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconNotificationDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_notification_default.d03cd86c210bc3fa551fc9d8e962a280.svg";